import '@/scss/single/product/product.scss';
import {updateSku} from "@/js/single/product/components/updateSku";
import * as $ from 'jquery';
import {productVideo} from "@/js/single/product/components/productVideo";

productVideo();
$(window).on('load', () => {
    updateSku();
});
document.addEventListener('click', (e) => {
    const imageWrap = e.target.closest('.woocommerce-product-gallery__image');

    if (!imageWrap) return;

    e.preventDefault();

    imageWrap.querySelector('a')?.click();
});